import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { adminStore } from "../stores/AdminStore";

export const AdminMenu: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await adminStore.logout();
    navigate("/gerenciar", { replace: true });
  };

  return (
    <div className="container-fluid bg_branco">
      <div className="container">
        <div className="row">
          <div
            className="col-md-12"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <ul className="nav-menu" style={{ marginBottom: 0 }}>
              <li>
                <Link
                  to="/gerenciar/novoProduto"
                  className={`bt ${location.pathname === "/gerenciar/novoProduto" ? "active" : ""}`}
                >
                  Novo Produto
                </Link>
              </li>
              <li>
                <Link
                  to="/gerenciar/produtos"
                  className={`bt ${location.pathname === "/gerenciar/produtos" ? "active" : ""}`}
                >
                  Produtos
                </Link>
              </li>
              <li>
                <Link
                  to="/gerenciar/pedidos"
                  className={`bt ${location.pathname === "/gerenciar/pedidos" ? "active" : ""}`}
                >
                  Pedidos
                </Link>
              </li>
              <li>
                <button onClick={handleLogout} className={`bt`}>
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
